import { render, staticRenderFns } from "./entry_sjh4.vue?vue&type=template&id=25a2c930&scoped=true"
import script from "./entry_sjh4.vue?vue&type=script&lang=js"
export * from "./entry_sjh4.vue?vue&type=script&lang=js"
import style0 from "./entry_sjh4.vue?vue&type=style&index=0&id=25a2c930&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a2c930",
  null
  
)

export default component.exports